import { httpClient, resolveApiUrl } from '#shared/api'
import SendOrderFeedbackPayload from '../model/send-order-feedback-payload'

export default async function sendOrderFeedback(payload: SendOrderFeedbackPayload, role: 'client' | 'staff') {
  await httpClient.post('feedback/' + role, {
    json: payload,
    prefixUrl: resolveApiUrl('@sd-orders'),
  })
}
